import { Show } from "../../constants/schema.js";
import { ShowMode } from "../../engine/modules/editor/state.js";
import { getSourceView } from "../../engine/modules/editor/view.js";
import { getTablePoint, getVisibleColumnIds } from "../../konva/scene/viewLayout.js";
import { calcTableHeight, calcTableWidths, calcViewTableWidths, getWidthGeneration } from "../calcTable.js";
//#region src/utils/draw-relationship/calc.ts
var tableSizeCaches = {
	document: /* @__PURE__ */ new WeakMap(),
	flow: /* @__PURE__ */ new WeakMap()
};
function tableSize(state, table, source) {
	const cache = tableSizeCaches[source];
	const pending = source === "document" ? documentTableSize(state, table) : viewTableSize(state, table, source);
	const cached = cache.get(table);
	if (cached?.key === pending.key) return cached;
	const size = pending.measure();
	cache.set(table, size);
	return size;
}
function documentTableSize(state, table) {
	const { settings } = state;
	const show = settings.show & ~(Show.hideReferentialAction | Show.hideTableGroup | Show.hideMemo);
	const key = `${getWidthGeneration()}|${show}|${settings.maxWidthComment}|${settings.nameViewMode}|${table.ui.widthName}|${table.ui.widthLogicalName}|${table.ui.widthComment}|${table.columnIds.length}`;
	return {
		key,
		measure: () => ({
			key,
			width: calcTableWidths(table, state).width,
			height: calcTableHeight(table)
		})
	};
}
function viewTableSize(state, table, source) {
	const { nameViewMode } = state.settings;
	const showMode = getSourceView(state, source)?.showMode ?? ShowMode.allFields;
	const columnIds = getVisibleColumnIds(state, table, source);
	const key = `${getWidthGeneration()}|${nameViewMode}|${table.ui.widthName}|${table.ui.widthLogicalName}|${table.columnIds.length}|${showMode}|${columnIds.length}`;
	return {
		key,
		measure: () => ({
			key,
			width: calcViewTableWidths(table, state, columnIds).width,
			height: calcTableHeight(table, columnIds.length, source)
		})
	};
}
function tableToObjectPoint(state, table, source = "document") {
	const { width, height } = tableSize(state, table, source);
	const { x, y } = getTablePoint(state, table, source);
	return {
		width,
		height,
		top: {
			x: x + width / 2,
			y
		},
		bottom: {
			x: x + width / 2,
			y: y + height
		},
		left: {
			x,
			y: y + height / 2
		},
		right: {
			x: x + width,
			y: y + height / 2
		},
		lt: {
			x,
			y
		},
		rt: {
			x: x + width,
			y
		},
		lb: {
			x,
			y: y + height
		},
		rb: {
			x: x + width,
			y: y + height
		}
	};
}
function euclideanDistance(a, b) {
	return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
}
//#endregion
export { euclideanDistance, tableToObjectPoint };
